import { http } from "helpers/Http";
import { IProductFull, IProductList } from "types/Product";

export async function fetchAPIProduct(id: number): Promise<IProductList> {
    const url = `products?place_id=${id}&show_additional=false&group_results=true&get_details=false&simple_mode=true`;
    const data = http.get(url).then((response) => response.data);
    return data;
}

export async function fetchAPIProductId(id: number): Promise<IProductFull> {
    const url = `products/${id}`;
    const data = http.get(url).then((response) => response.data);
    return data;
}